import axios from 'axios';

import { setAlert } from './alert';
import { changeLoader } from './loader';
import { METODOS } from './types';

export const buscarMetodos = () => async dispatch => {
    try {
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/metodos/listar`);
        await dispatch({ type: METODOS.BUSCAR, payload: res.data.metodos });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};


export const buscarMetodosTipo = (tipo) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = { tipo };

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/metodos/filtrar`, body, config);
        await dispatch({ type: METODOS.BUSCAR, payload: res.data.metodos });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};